import { Link, Location } from "react-router-dom";
import { useTranslation } from "react-i18next";

import SidePanelSection from "./../../../SidePanelSection/SidePanelSection";
import QueryLoader from "components/QueryLoader";
import { levelsQuery, Level } from "services/levels";
import { buildExerciseLevelPath, isExerciseLevelActive } from "pages/Exercises/urlState";

type Props = {
  location: Location;
};

export default function LevelSection(props: Props) {
  const { t } = useTranslation();

  return (
    <QueryLoader query={levelsQuery()}>
      {levels => (
        <SidePanelSection
          sectionTitle={t("Common.labels.level")}
          list={levels}
          location={props.location}
          tagName={LevelListItem}
          isReducedList={true}
        />
      )}
    </QueryLoader>
  );
}

type LevelListItemProps = {
  item: Level;
  location?: Location;
};

function LevelListItem(props: LevelListItemProps) {
  const path = buildExerciseLevelPath(props.item.id);
  const isActive =
    props.location !== undefined && isExerciseLevelActive(props.location, props.item.id);
  return (
    <li className={isActive ? "active" : ""}>
      <Link to={path}>{props.item.name}</Link>
    </li>
  );
}
